import type { GalleryItem } from '../types/content';

export const gallery: GalleryItem[] = [
  {
    type: 'interior',
    title: { en: 'Professional Ceiling & Wall Paint', es: 'Pintura Profesional de Techos y Paredes' },
    description: {
      en: 'Expert interior painting creating clean, finished surfaces. Professional preparation and premium finishes.',
      es: 'Pintura interior experta con superficies limpias y bien terminadas. Preparación profesional y acabados premium.',
    },
    location: 'Columbus, Ohio',
    image: 'https://imgur.com/mE6Rqdj.jpg',
    alt: {
      en: 'Freshly painted smooth ceiling and walls by Win21der in Columbus, Ohio',
      es: 'Techo y paredes recién pintados por Win21der en Columbus, Ohio',
    },
  },
  {
    type: 'interior',
    title: { en: 'Drywall Finish & Interior Paint', es: 'Acabado de Drywall y Pintura Interior' },
    description: {
      en: 'Professional drywall work and interior painting. Clean, finished surfaces ready for use.',
      es: 'Trabajo profesional de drywall y pintura interior. Superficies limpias y terminadas, listas para usar.',
    },
    location: 'Columbus, Ohio',
    image: 'https://imgur.com/OJwUIT5.jpg',
    alt: {
      en: 'Textured drywall finish and interior painting in Columbus, Ohio',
      es: 'Acabado texturizado de drywall y pintura interior en Columbus, Ohio',
    },
  },
  {
    type: 'exterior',
    title: { en: 'Professional Fence Staining & Paint', es: 'Tinte y Pintura Profesional de Cercas' },
    description: {
      en: 'Expert exterior fence staining and finishing. Durable, weather-resistant, professional results.',
      es: 'Tinte y acabado experto de cercas exteriores. Resultados profesionales, duraderos y resistentes al clima.',
    },
    location: 'Columbus, Ohio',
    image: 'https://cdn.magicpatterns.com/uploads/gBavGcS3zsijYW8fwdoYTf/Despues1.jpg',
    alt: {
      en: 'Wood fence staining and exterior finishing in Columbus, Ohio',
      es: 'Tinte de cerca de madera y acabado exterior en Columbus, Ohio',
    },
  },
];
